import { notificationPreferencesApi } from "@facade/services";
import { queryOptions } from "@tanstack/react-query";

export const notificationPreferencesQueryKeys = {
  all: ["notification-preferences"] as const,
};

export const notificationPreferencesQueries = {
  detail: () =>
    queryOptions({
      queryKey: notificationPreferencesQueryKeys.all,
      queryFn: notificationPreferencesApi.get,
    }),
};
